import state from './state';
import actions from './actions';
import mutations from './mutations';
import modules from './modules';

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  modules,
};
